@let apiUrl = apiUrl$ | async;
@if (currentStoreUuid$ | async; as currentStoreUuid) {
  @if (allowedStoresUuids$ | async; as allowedStoresUuids) {
    @if (allowedStoresUuids | isStoreUuid: currentStoreUuid) {
      <app-button (buttonClicked)="onClick()" [label]="config.text" [theme]="'ACTION'"></app-button>
      <dialog #dialogRef class="middle-office-dialog">
        @if (apiUrl) {
          <iframe [src]="apiUrl | safeUrl" class="middle-office-iframe"></iframe>
        }
      </dialog>
    }
  }
}
